import { Box, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlinePencilIcon } from '@tempmee/react-icons';

// 18px vertical padding on each row — not in DS SpacingScale (no 4.5 step).
const ROW_PADDING_BLOCK = 18;

interface AdjustmentItemProps {
  label: string;
  adjustedLabel?: string;
  defaultValue: string;
  value?: string;
  isAdjusted?: boolean;
  onEditClicks?: () => void;
  firstRow?: boolean;
  disabled?: boolean;
}

const AdjustmentItem = ({
  label,
  adjustedLabel,
  defaultValue,
  value,
  isAdjusted,
  onEditClicks = () => {},
  firstRow,
  disabled,
}: AdjustmentItemProps) => (
  <Box
    style={{
      paddingBlock: ROW_PADDING_BLOCK,
      borderTop: firstRow ? `1px solid ${colors.neutral[100]}` : undefined,
      borderBottom: `1px solid ${colors.neutral[100]}`,
    }}
  >
    <Row justify="between" align="center">
      <Typography bold color={colors.neutral[600]}>
        {label}
      </Typography>

      <Row align="center" gap={2}>
        <Typography
          color={colors.neutral[500]}
          style={{ textDecoration: isAdjusted ? 'line-through' : 'none' }}
        >
          {defaultValue}
        </Typography>

        {!disabled && (
          <Box
            data-testid="edit-button"
            onClick={onEditClicks}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <OutlinePencilIcon color={colors.secondary[500]} width={20} height={20} />
          </Box>
        )}
      </Row>
    </Row>

    {isAdjusted && (
      <Row justify="between" style={{ marginTop: 19 }}>
        <Typography bold color={colors.secondary[500]}>
          {adjustedLabel}
        </Typography>
        <Typography color={colors.neutral[500]}>{value}</Typography>
      </Row>
    )}
  </Box>
);

export default AdjustmentItem;
